import { tacticMap } from '../tactics/tacticKeys';

// tactics
export function createDataStore(tactic) {
  return new tacticMap[tactic].dataStore();
}
export function getTacticPanel(tactic) {
  return tacticMap[tactic].tacticPanel;
}
export function getAddTacticPanel(tactic) {
  return tacticMap[tactic].addTacticPanel;
}
export function getWrapper(tactic) {
  return tacticMap[tactic].wrapper;
}
export function getChartSoftOrderComponent(tactic) {
  return tacticMap[tactic].chartSoftOrderComponent;
}
export function getDocumentation(tactic) {
  return tacticMap[tactic].documentation;
}
export function getAlertDetailsComponent(tactic) {
  return tacticMap[tactic].alertDetailsComponent;
}
export function getAlertTableSetupComponent(tactic) {
  return tacticMap[tactic].alertTableSetupComponent;
}



